module.exports = __webpack_public_path__ + "a3845edce4db00e5060c4a94a19dd06e.pdf";